import {  useRef, useState } from "react";
import { FaWindowClose } from "react-icons/fa";
import { FiPlusCircle } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";
import { addApplicationNumber, getApplicationUploadFile } from "JS/API";

const ApplicationNumberModal = ({ setNumberModal, markClassList, id, onSuccess }) => {
    const [applicationItems, setApplicationItems] = useState([
        {
            applicationNumber: "",
            applicationDate: "",
            selectedTypes: [],
            fileName: "",
            status: "",
        },
    ]);

    const fileInputRefs = useRef([]);

    const handleAddItem = () => {
        setApplicationItems((prev) => [
            ...prev,
            {
                applicationNumber: "",
                applicationDate: "",
                selectedTypes: [],
                fileName: "",
                status: "",
            },
        ]);
    };

    const handleChangeItem = (index, field, value) => {
        setApplicationItems((prev) =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        );
    };



    const handleClearFile = (index) => {
        handleChangeItem(index, "fileName", "");
        if (fileInputRefs.current[index]) {
            fileInputRefs.current[index].value = null;
        }
    };


    const handleRemoveItem = (index) => {
        setApplicationItems((prev) => prev.filter((_, i) => i !== index));
    };

    const formatApplicationNumber = (value) => {
        const numeric = value.replace(/[^0-9]/g, "").slice(0, 13);

        if (numeric.length <= 2) return numeric;
        if (numeric.length <= 6) return `${numeric.slice(0, 2)}-${numeric.slice(2)}`;
        return `${numeric.slice(0, 2)}-${numeric.slice(2, 6)}-${numeric.slice(6)}`;
    };


    const unformatApplicationNumber = (formatted) => {
        return formatted.replace(/[^0-9]/g, "");
    };

    const handleSave = async () => {
        if (
            applicationItems.length === 0 ||
            applicationItems.some((item) => item.selectedTypes.length === 0)
        ) {
            alert("출원정보와 상품분류를 모두 입력해주세요.");
            return;
        }


        const payload = applicationItems.map((item) => ({
            detail_items_pks: item.selectedTypes, 
            application_number: unformatApplicationNumber(item.applicationNumber),
            application_date: item.applicationDate,
            status: "출원",
            apply_agent_pk: id,
        }));


        try {
            const res = await addApplicationNumber(payload);
            const savedItems = res?.data?.response_data;
            if (Array.isArray(savedItems)) {
                setApplicationItems((prev) =>
                    prev.map((item, i) => ({
                        ...item,
                        applicationId: savedItems[i]?.application_info_id || null,
                    }))
                );

                // 파일이 있으면 여기서 바로 업로드
                for (let i = 0; i < savedItems.length; i++) {
                    const id = savedItems[i]?.application_info_id;
                    const fileName = applicationItems[i]?.fileName;
                    const input = fileInputRefs.current[i];

                    if (fileName && input?.files?.[0]) {
                        const file = input.files[0];

                        const formData = new FormData();
                        formData.append("file_type", "application");
                        formData.append("file", file, file.name);

                        try {
                            const uploadRes = await getApplicationUploadFile(id, formData);
                            console.log(`파일 업로드 완료 (index ${i}):`, uploadRes?.data);
                        } catch (err) {
                            console.error(`파일 업로드 실패 (index ${i}):`, err);
                            alert(`파일 업로드 실패: ${file.name}`);
                        }
                    }
                }

                alert("저장되었습니다.");
                setNumberModal(false);
                onSuccess();
            }
        } catch (err) {
            console.error("저장 실패:", err);
            alert("저장 중 오류가 발생했습니다.");
        }
    };



    return (
        <div className="modal-background">
            <div className="personnel-modal-container application">
                <div className="personnel-modal-header">
                    <h3 className="personnel-modal-title">출원정보 등록</h3>
                    <div className="personnel-modal-close" onClick={() => setNumberModal(false)}>
                        <FaWindowClose />
                    </div>
                </div>
                <div className="application-info-wrap">
                    {applicationItems.map((item, index) => (
                        <div className="item" key={index}>
                            <FaTimes
                                onClick={() => handleRemoveItem(index)}
                                style={{
                                    position: "absolute",
                                    top: '10',
                                    right: '10',
                                    cursor: "pointer",
                                    color: "#888",
                                    fontSize: "16px",
                                }}
                                title="삭제"
                            />
                            <h4>출원번호</h4>
                            <input
                                type="text"
                                value={item.applicationNumber}
                                onChange={(e) =>
                                    handleChangeItem(index, "applicationNumber", formatApplicationNumber(e.target.value))
                                }
                                placeholder="예: 45-2023-0004053"
                            />

                            <h4>출원일자</h4>
                            <input
                                type="date"
                                value={item.applicationDate}
                                onChange={(e) =>
                                    handleChangeItem(index, "applicationDate", e.target.value)
                                }
                            />

                            <h4>상품분류</h4>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                {markClassList.map((detailItem) => (
                                    <label key={detailItem.detail_item_pk} style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={item.selectedTypes.includes(detailItem.detail_item_pk)}
                                            onChange={() => {
                                                const newSelected = item.selectedTypes.includes(detailItem.detail_item_pk)
                                                    ? item.selectedTypes.filter((pk) => pk !== detailItem.detail_item_pk)
                                                    : [...item.selectedTypes, detailItem.detail_item_pk];
                                                handleChangeItem(index, "selectedTypes", newSelected);
                                            }}
                                        />
                                        <span style={{ marginLeft: "4px" }}>{detailItem.mark_class}류</span>
                                    </label>
                                ))}
                            </div>

                            <div style={{ display: "flex", gap: "10px" }}>
                                <h4>출원서 첨부</h4>
                                <button
                                    type="button"
                                    onClick={() => fileInputRefs.current[index]?.click()}
                                    style={{
                                        backgroundColor: "#888",
                                        width: "86px",
                                        borderRadius: "4px",
                                        color: "white",
                                        marginBottom: "10px",
                                    }}
                                >
                                    파일 첨부
                                </button>
                            </div>

                            {item.fileName && (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        border: "1px solid #888",
                                        padding: "6px 10px",
                                        borderRadius: "4px",
                                        backgroundColor: "#F4F4F4",
                                        marginBottom: "17px",
                                    }}
                                >
                                    <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {item.fileName}
                                    </span>
                                    <FaTimes
                                        onClick={() => handleClearFile(index)}
                                        style={{ cursor: "pointer", color: "#888" }}
                                    />
                                </div>
                            )}

                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={(el) => (fileInputRefs.current[index] = el)}
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        handleChangeItem(index, "fileName", file.name);
                                    }
                                }}
                            />
                            {/* <h4>출원상태</h4>
                            <input
                                type="text"
                                value={item.status}
                                onChange={(e) =>
                                    handleChangeItem(index, "status", e.target.value)
                                }
                                placeholder="예: 접수, 심사중, 등록 등"
                            /> */}
                        </div>
                    ))}

                    {/* 출원정보 추가 버튼 */}
                    <div className="application-add-box">
                        <button type="button" onClick={handleAddItem}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    gap: "7px",
                                }}
                            >
                                <FiPlusCircle size={20} />
                                <p>출원정보 추가</p>
                            </div>
                        </button>
                    </div>

                    {/* 저장/취소 */}
                    <div className="button-wrap">
                        <button onClick={handleSave}>저장</button>
                        <button onClick={() => setNumberModal(false)}>취소</button>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ApplicationNumberModal;
